import React, { useState } from "react";


const FAQSection = () => {
  const faqs = [
    {
      question: "What is Poll Sphere?",
      answer: "Poll Sphere is a survey platform that rewards you for sharing your opinions. Complete surveys, participate in market research, and earn real money for your valuable insights."
    },
    {
      question: "Who can join Poll Sphere?",
      answer: "Anyone 18 years or older can join Poll Sphere! Whether you're a student, working professional, or homemaker, you can sign up and start earning by completing surveys."
    },
    {
      question: "How do I sign up?",
      answer: "Simply click on 'Get Started' and sign up using your Google account. Complete your profile to start receiving survey invitations matched to your interests and demographics."
    },
    {
      question: "How much can I earn?",
      answer: "Earnings vary based on survey length and complexity. Typical surveys pay ₹10-₹100, while longer research studies can pay ₹200 or more. The more surveys you complete, the more you earn!"
    },
    {
      question: "How does the referral program work?",
      answer: "Share your unique referral link with friends and family. When they sign up and complete surveys, you earn 10% of their reward points as commission. There's no limit to how many people you can refer!"
    },
    {
      question: "How do I get paid?",
      answer: "Once you reach the minimum withdrawal amount, you can redeem your earnings via UPI, bank transfer, or popular e-wallets. Payments are typically processed within 3-5 business days."
    },
    {
      question: "Why am I not receiving surveys?",
      answer: "Survey availability depends on your profile demographics and the current research requirements. Make sure your profile is complete and accurate to receive more survey invitations."
    },
    {
      question: "What happens if I get disqualified from a survey?",
      answer: "Sometimes you may not match the specific criteria for a survey and get screened out. Don't worry - this is normal! You can try other available surveys and will still receive new opportunities."
    },
    {
      question: "Is my personal information safe?",
      answer: "Absolutely! We take privacy seriously. Your personal information is encrypted and never shared with third parties without your consent. Survey responses are anonymized for research purposes."
    },
    {
      question: "Can I use Poll Sphere on my mobile device?",
      answer: "Yes! Poll Sphere is available on both Android and iOS. Download our mobile app to complete surveys anytime, anywhere and never miss a survey opportunity."
    }
  ];
  

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-section py-5" id="faq">
       <div className="heading-section text-center pb-md-5 mt-4">
            <h2>Frequently Asked Questions</h2>
          </div>
      <div className="container">
       
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{index + 1}. {faq.question}</span>
                <span className="faq-icon">{activeIndex === index ? "Hide" : "Show"}</span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
